import { PortalkonfigurationDisplayModel } from '@/api/model-index';
import { PortalContextService } from '@/core/services/portal-context.service';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { StateService } from '@/core/services/state.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'anfrage-infoarea',
  templateUrl: './anfrage-infoarea.component.html',
  styleUrls: ['./anfrage-infoarea.component.scss']
})
export class AnfrageInfoareaComponent {

  protected portalkonfiguration: PortalkonfigurationDisplayModel;

  public get showAnfrageInfo() {
    return this.stateService.showAnfrageInfo;
  }

  public get anfrageId() {
    return this.portalContextService.CurrentAnfrage.id;
  }

  public get scope() {
    return this.portalContextService.CurrentAnfrage.objektTyp!;
  }

  public get chatIsVisible() {
    return this.stateService.showAnfrageInfo && this.portalkonfiguration.nachrichtenInSidebarAnzeigen;
  }

  constructor(protected stateService: StateService, protected portalContextService: PortalContextService, protected stammdatenService: StammdatenService) { 
    this.portalkonfiguration = this.stammdatenService.Portalkonfiguration;
  }

  onToggleClick() {
    this.stateService.ToggleAnfrageInfo();
  }
}
